import React, { useEffect, useState, useRef } from "react";
import { PhotoIcon } from "@heroicons/react/24/solid";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { baseUrl } from "../../../Environments/environment";
import { useAuth } from "../../../Contexts/AuthContext/AuthContext";
import { useProperty } from "../../../Contexts/PropertyContext/PropertyContext";
import { toast } from "react-toastify";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { useLocation, useNavigate } from "react-router-dom";
import { apiClient } from "../../../api";
import {
  Delete,
  DeleteIcon,
  LucideDelete,
  Trash,
  TrashIcon,
  Info,
} from "lucide-react";
import { BUSINESS_TYPES } from "../../../utils/businessTypes";
import BusinessCombobox from "../BusinessCombobox";

import Stepper from "./Stepper";
import LinkQRStep from "./LinkQRStep";
import QRCodeKit from "../../Dashboard/QRCodeKit/QRCodeKit";

const steps = [
  { id: 1, name: "Business Profile" },
  { id: 2, name: "Link QR Stand" },
  { id: 3, name: "Shop QR Kit" },
];

const SORTED_BUSINESS_TYPES = [...BUSINESS_TYPES].sort((a, b) =>
  a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
);

export default function AddProperty() {
  const { accessToken, user } = useAuth();
  const { selectProperty } = useProperty();
  const [currentStep, setCurrentStep] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const { isComplete, propertyId, isSubaccountCreated } = location.state || {};
  const [propertyName, setPropertyName] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [reviewUrl, setReviewUrl] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [propertyEmail, setPropertyEmail] = useState(user?.email || "");
  const [website, setWebsite] = useState("");
  const [businessType, setBusinessType] = useState("hotel");
  const [about, setAbout] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [country, setCountry] = useState("");
  const [iso2, setIso2] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [address, setAddress] = useState("");
  const [standardCheckinTime, setStandardCheckinTime] = useState("");
  const [standardCheckoutTime, setStandardCheckoutTime] = useState("");
  const [timezone, setTimezone] = useState("");
  const [defaultNewDayTime, setDefaultNewDayTime] = useState("");
  const [logo, setLogo] = useState(null);
  const [cover, setCover] = useState(null);
  const [logoName, setLogoName] = useState("");
  const [coverName, setCoverName] = useState("");
  const [firstForm, setFirstForm] = useState(true);
  const [secondForm, setSecondForm] = useState(false);
  const [thirdForm, setThirdForm] = useState(false);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState();
  const [loading, setLoading] = useState(false);
  const [timezones, setTimezones] = useState([]);
  const [phoneBuy, setPhoneBuy] = useState(
    phoneNumbers.length > 0 ? phoneNumbers[0].phoneNumber : "",
  );
  const [logoUrl, setLogoUrl] = useState(null);
  const [coverUrl, setCoverUrl] = useState(null);
  const [nextContact, setNextContact] = useState(false);
  const [disableChange, setDisableChange] = useState(false);
  const [property, setProperty] = useState();
  const [countries, setCountries] = useState([]);
  const [propertyData, setPropertyData] = useState(null);
  const [mode, setMode] = useState("buy"); // "buy" | "host"
  const [initialRating, setInitialRating] = useState(null);
  const [targetRating, setTargetRating] = useState("");
  const [placeId, setPlaceId] = useState(null);
  const [googleFields, setGoogleFields] = useState({});
  const [logoAutoFilled, setLogoAutoFilled] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);

  const isFromGoogle = (field) => Boolean(googleFields[field]);
  const isEditing = isComplete === false;
  const showFormFields = Boolean(placeId) || isEditing;

  const hasVisibleRemainingFields = showFormFields;

  const stepRef = useRef(currentStep);
  useEffect(() => {
    stepRef.current = currentStep;
  }, [currentStep]);

  useEffect(() => {
    if (sessionStorage.getItem("reload_from_step") === "true") {
      sessionStorage.removeItem("reload_from_step");
      navigate("/dashboard", { replace: true });
    }

    const handleBeforeUnload = () => {
      if (stepRef.current === 2 || stepRef.current === 3) {
        sessionStorage.setItem("reload_from_step", "true");
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [navigate]);

  useEffect(() => {
    if (isComplete === false) {
      const fetchData = async () => {
        setFirstForm(false);
        setSecondForm(false);
        setThirdForm(true);

        await fetchPropertyData(); // Await the fetchPropertyData function
      };

      fetchData(); // Call the async function
    }
  }, [isComplete]);

  console.log("phoneBuy", phoneBuy);
  const fetchPropertyData = async () => {
    try {
      const response = await apiClient.get(`${baseUrl}/property/${propertyId}`);
      if (response.ok) {
        const newToken = response.headers.get("Authorization");
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
        }
      }
      console.log(response);

      const { _, setting } = response.data.result;
      const property = response.data.result.property.property;
      console.log(property);

      // Map the fetched data to your state variables
      setPropertyName(property.name || "");
      setPropertyEmail(property.email || "");
      setPhoneNumber(property.phoneNumber || "");
      setWebsite(property.website || "");
      setBusinessType(property.businessType || "hotel");
      setAbout(property.about || "");
      setCountry(property.country || "");
      setState(property.state || "");
      setCity(property.city || "");
      setAddress(property.address || "");
      setZipcode(property.zipcode || "");
      setCountryCode(property.countryCode || "");
      setLogo(property.logoUrl || null);
      setCover(property.coverUrl || null);
      setStandardCheckinTime(setting.standardCheckinTime || "");
      setStandardCheckoutTime(setting.standardCheckoutTime || "");
      setTimezone(setting.timezone || "");
      setLogoUrl(property.logoUrl || null);
      setCoverUrl(property.coverUrl || null);
      setDefaultNewDayTime(setting.defaultNewDayTime || "");
      const initRating = property.initialRating || null;
      setInitialRating(initRating);

      let initialTarget = property.targetRating || "";
      if (!initialTarget && initRating !== null) {
        const numRating = parseFloat(initRating);
        if (!isNaN(numRating)) {
          initialTarget = Math.min(5, numRating + 0.1).toFixed(1);
        }
      }
      setTargetRating(initialTarget);

      setPropertyData(response.data);
      setProperty(property);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Error fetching property data.";
      console.log(error);
      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    if (iso2) {
      console.log("helo", iso2);
      //fetchPhoneNumbers();
    }
  }, [iso2]);
  useEffect(() => {
    if (!isTyping) return; // ⬅ block backend/programmatic updates

    const timeout = setTimeout(() => {
      if (searchQuery.length >= 4) {
        handleSearch(searchQuery);
      } else {
        setSuggestions([]);
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [searchQuery, isTyping]);

  const handleSearch = async (value) => {
    if (value.length < 4) {
      setSuggestions([]);
      setSearchLoading(false);
      return;
    }

    setSearchLoading(true);
    try {
      const response = await apiClient.get(
        `${baseUrl}/property/search?query=${encodeURIComponent(value)}`,
      );

      if (response.data.result.length) {
        setSuggestions(response.data.result);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error("Error search:", error);
    } finally {
      setSearchLoading(false);
    }
  };

  const resolvePhotoUrl = (photo) => {
    if (!photo) return null;
    if (typeof photo === "string") return photo;
    return photo.url || photo.photoUrl || photo.uri || null;
  };

  const applyGoogleLogo = async (data) => {
    let logoSource =
      data?.logo || data?.logoUrl || data?.icon || data?.profilePhoto || null;

    if (!logoSource && Array.isArray(data?.photos) && data.photos.length > 0) {
      const randomPhoto =
        data.photos[Math.floor(Math.random() * data.photos.length)];
      logoSource = resolvePhotoUrl(randomPhoto);
    }

    if (!logoSource) {
      setLogoAutoFilled(false);
      return;
    }

    setLogoAutoFilled(true);
    setLogoUrl(logoSource);

    try {
      const file = await urlToFile(logoSource, "google-logo.jpg");
      setLogo(file);
      setLogoName("google-logo.jpg");
    } catch (error) {
      console.error("Could not fetch Google logo:", error);
      setLogo(logoSource);
    }
  };

  const buildGoogleFields = (data, phoneFilled) => {
    const filled = {};
    if (data?.name) filled.propertyName = true;
    if (data?.website) filled.website = true;
    if (data?.editorial_summary?.overview || data?.about) filled.about = true;
    if (data?.parsedAddress?.country) filled.country = true;
    if (data?.parsedAddress?.state) filled.state = true;
    if (data?.parsedAddress?.city) filled.city = true;
    if (data?.parsedAddress?.zipcode) filled.zipcode = true;
    if (data?.formatted_address) filled.address = true;
    if (data?.businessType) filled.businessType = true;
    if (data?.url) filled.reviewUrl = true;
    if (data?.rating != null && data?.rating !== "") filled.rating = true;
    if (phoneFilled) filled.phone = true;
    if (data?.email) filled.email = true;
    return filled;
  };

  const handleSelect = async (place) => {
    console.log("Selected place:", place);
    setIsTyping(false);
    setSuggestions([]);
    setIsFocused(false);
    setDetailsLoading(true);
    try {
      const checkResponse = await apiClient.post(`${baseUrl}/property/checkPlaceIdExists`, {
        placeId: place.place_id,
      });

      if (checkResponse.data.result.exists) {
        const emailMsg = checkResponse.data.result.email
          ? ` (Registered by ${checkResponse.data.result.email})`
          : "";
        toast.error(`This property is already registered${emailMsg}.`);
        setDetailsLoading(false);
        return;
      }

      const response = await apiClient.get(
        `${baseUrl}/property/details?place_id=${place.place_id}`,
      );

      console.log("Full business details:", response);
      setPlaceId(place.place_id);
      const data = response.data.result;

      let phoneFilled = false;
      if (data?.international_phone_number) {
        const intlPhone = data.international_phone_number;
        const phoneCode = intlPhone.match(/^\+?\d+/)?.[0] || "";
        const localNumber = intlPhone.replace(phoneCode, "").trim();

        setCountryCode(phoneCode);
        setPhoneNumber(normalizePhone(localNumber));
        phoneFilled = true;
      }

      setPropertyName(data?.name || "");
      setPropertyEmail(data?.email || user?.email || "");
      setWebsite(data?.website || "");
      setAbout(data?.editorial_summary?.overview || data?.about || "");
      setCountry(data?.parsedAddress?.country || "");
      setIso2(data?.parsedAddress?.countryCode || "");
      setState(data?.parsedAddress?.state || "");
      setCity(data?.parsedAddress?.city || "");
      setZipcode(data?.parsedAddress?.zipcode || "");
      setAddress(data?.formatted_address || "");
      setBusinessType(data?.businessType || "hotel");
      setReviewUrl(data?.url || "");
      const fetchedRating = data?.rating ?? "";
      setInitialRating(fetchedRating);
      setGoogleFields(buildGoogleFields(data, phoneFilled));
      await applyGoogleLogo(data);
    } catch (error) {
      console.error("Error fetching business details:", error);
      toast.error("Could not load business details from Google.");
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    const selectedCountryIso2 =
      countries.find((countryItem) => countryItem.name === selectedCountry)
        ?.iso2 || "";
    setCountry(selectedCountry);
    setIso2(selectedCountryIso2);
  };
  const handleDropLogoFile = (e) => {
    e.preventDefault();
    const droppedFiles = e.dataTransfer.files;
    if (droppedFiles.length > 0) {
      const newFiles = Array.from(droppedFiles);
      if (newFiles[0].type.startsWith("image/") === false) {
        alert("Please upload a valid image file");
        return;
      }
      if (newFiles[0].size > 10 * 1024 * 1024) {
        alert("Please upload a file smaller than 10MB");
        return;
      }
      setLogoUrl(URL.createObjectURL(newFiles[0]));
      setLogo(newFiles[0]);
      setLogoName(newFiles[0]?.name || "");
    }
  };
  const handleDropCoverFile = (e) => {
    e.preventDefault();
    const droppedFiles = e.dataTransfer.files;
    if (droppedFiles.length > 0) {
      const newFiles = Array.from(droppedFiles);
      if (newFiles[0].type.startsWith("image/") === false) {
        alert("Please upload a valid image file");
        return;
      }
      if (newFiles[0].size > 10 * 1024 * 1024) {
        alert("Please upload a file smaller than 10MB");
        return;
      }
      setCoverUrl(URL.createObjectURL(newFiles[0]));
      setCover(newFiles[0]);
      setCoverName(newFiles[0]?.name || "");
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await apiClient.get(`${baseUrl}/country`);

      setCountries(response.data.result.countries);
      if (property && property.country) {
        console.log("here");
        const iso2 = countries.find(
          (countryItem) => countryItem.name === property.country,
        )?.iso2;
        setIso2(iso2);
      }
    } catch (error) {
      console.log(error);
      const errorMessage =
        error.response?.data?.message || "Error fetching countries.";
      toast.error(errorMessage);
      console.error("Error fetching countries:", errorMessage);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, [accessToken, property]);

  const handlePageOneBack = () => {
    // Prefer real browser history so user returns to exact origin page.
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    // Safe fallback when opened directly without in-app history.
    navigate("/propertyhome");
  };
  // property onboard api call
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isEditing && !placeId) {
      toast.error("Please select your business from Google search results.");
      return;
    }

    if (!logo && !logoUrl) {
      toast.error("Please upload a logo");
      return;
    }

    setLoading(true); // Set loading state to true when form submission starts
    const url = `${baseUrl}/property/checkEmailExists`;
    const response = await apiClient.post(url, {
      email: propertyEmail,
    });
    if (response.data.result.exists) {
      toast.error("Email already exists. Please use a different email.");
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("name", propertyName);
    if (propertyEmail) formData.append("email", propertyEmail);
    formData.append("website", website);
    formData.append("businessType", businessType || "hotel");
    formData.append("reviewUrl", reviewUrl);
    // formData.append("about", about);
    if (about !== "") formData.append("about", about);
    formData.append("phoneNumber", normalizePhone(phoneNumber));
    if (initialRating !== null && initialRating !== undefined) formData.append("initialRating", initialRating);
    if (targetRating) formData.append("targetRating", targetRating);
    formData.append("countryCode", countryCode);
    formData.append("country", country);
    formData.append("state", state);
    formData.append("city", city);
    formData.append("zipcode", zipcode);
    formData.append("address", address);
    formData.append("standardCheckinTime", standardCheckinTime);
    formData.append("standardCheckoutTime", standardCheckoutTime);
    formData.append("timezone", timezone);
    formData.append("defaultNewDayTime", defaultNewDayTime);
    if (logo instanceof File) {
      formData.append("logo", logo);
    } else if (typeof logo === "string" && logo) {
      formData.append("logoUrl", logo);
    } else if (logoUrl && !logo) {
      formData.append("logoUrl", logoUrl);
    }
    if (placeId) formData.append("placeId", placeId);
    try {
      let response;

      if (isComplete === false) {
        // Update existing property
        response = await apiClient.put(
          `${baseUrl}/property/${propertyId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${accessToken}`,
            },
            withCredentials: true,
          },
        );
        if (response.ok) {
          const newToken = response.headers.get("Authorization");
          if (newToken) {
            localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
          }
        }
        toast.success("Property updated successfully!");
        const updatedPropertyId = response.data.result.property._id;
        setProperty(response.data.result.property);
        if (updatedPropertyId) {
          selectProperty(updatedPropertyId);
          try {
            let list = JSON.parse(localStorage.getItem("propertiesList") || "[]");
            const index = list.findIndex(p => p._id === updatedPropertyId);
            if (index > -1) {
              list[index] = response.data.result.property;
            } else {
              list.push(response.data.result.property);
            }
            localStorage.setItem("propertiesList", JSON.stringify(list));
          } catch (e) {
            console.error(e);
          }
        }
        setSecondForm(false);
        setThirdForm(true);
        setCurrentStep(2);
      } else {
        // Create a new property
        response = await apiClient.post(`${baseUrl}/property`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
          withCredentials: true,
        });

        toast.success("Property added successfully!");
        const newPropertyId = response.data.result.property._id;
        setProperty(response.data.result.property);
        if (newPropertyId) {
          selectProperty(newPropertyId);
          try {
            let list = JSON.parse(localStorage.getItem("propertiesList") || "[]");
            list.push(response.data.result.property);
            localStorage.setItem("propertiesList", JSON.stringify(list));
          } catch (e) {
            console.error(e);
          }
        }
        setCurrentStep(2);
      }

      console.log(
        isComplete === false ? "Updated property" : "Added property",
        response.data,
      );
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Error in Property details";
      toast.error(errorMessage);
      console.error("Error:", errorMessage);
    } finally {
      setLoading(false); // Set loading state to false after the API call completes or fails
    }
  };

  const phoneRegex = /^\d{10}$/;

  const handleNextContact = () => {
    setNextContact(true);
  };

  const handleNextButton1 = async (e) => {
    e.preventDefault();
    try {
      const url = `${baseUrl}/property/checkEmailExists`;
      const response = await apiClient.post(url, {
        email: propertyEmail,
      });
      if (response.data.result.exists) {
        toast.error("Email already exists. Please use a different email.");
        return;
      }
    } catch (e) {
      console.error(e);
    }
  };
  const deleteLogo = () => {
    setLogo(null);
    setLogoUrl(null);
    setLogoName("");
    setLogoAutoFilled(false);
  };
  const deleteCover = () => {
    setCover(null);
    setCoverUrl(null);
    setCoverName("");
  };

  const handleBackButton1 = async () => {
    setFirstForm(true);
    setSecondForm(false);
  };
  const handleBackButton2 = () => {
    setSecondForm(true);
    setThirdForm(false);
  };

  const handleTimezoneChange = (e) => {
    const selectedIndex = e.target.selectedIndex; // Get the index of the selected option
    const selectedOption = e.target.options[selectedIndex].text; // Get the text of the selected option

    setTimezone(selectedOption);
  };

  function normalizePhone(input) {
    if (!input) return "";
    return String(input).replace(/[^\d]/g, "");
  }

  async function urlToFile(url, filename = "logo.jpg") {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch image");
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type || "image/jpeg" });
  }

  const resetGoogleSelection = () => {
    setPlaceId(null);
    setSearchQuery("");
    setPropertyName("");
    setGoogleFields({});
    setLogoAutoFilled(false);
    setLogo(null);
    setLogoUrl(null);
    setLogoName("");
    setPropertyEmail(user?.email || "");
    setWebsite("");
    setAbout("");
    setCountry("");
    setIso2("");
    setState("");
    setCity("");
    setZipcode("");
    setAddress("");
    setPhoneNumber(undefined);
    setReviewUrl("");
    setInitialRating(null);
    setTargetRating("");
    setBusinessType("hotel");
    setSuggestions([]);
  };

  const handleFinishSetup = async (id) => {
    try {
      if (id) {
        selectProperty(id);
      }
      navigate("/dashboard", { replace: true });
    } catch (error) {
      console.error(error);
      navigate("/propertyhome");
    }
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="min-h-screen bg-gray-300 px-4 py-8 pb-28 md:px-8 md:py-12 md:pb-32">
        <div className="mx-auto w-full max-w-6xl mb-8">
          <Stepper steps={steps} currentStep={currentStep} />
        </div>
        <div className="mx-auto w-full max-w-6xl">
          {currentStep === 1 && (
            <form
              id="add-property-form"
              className="mx-auto bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl sm:rounded-xl"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between border-b border-gray-100 px-4 py-3 sm:px-8 sm:py-4 gap-4 sm:gap-0">
                <div>
                  <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                    {showFormFields && !isEditing
                      ? "Complete your business profile"
                      : "Find your business"}
                  </h2>
                  <p className="mt-2 text-sm md:text-base text-gray-600">
                    {!placeId && !isEditing
                      ? "Search Google and select your business from the list."
                      : hasVisibleRemainingFields
                        ? "Fill in the details below that were not found on Google."
                        : "Review your selection and save to continue."}
                  </p>
                </div>
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto justify-end">
                  <a
                    href="http://review.onelyk.com/customer/new"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-semibold text-indigo-600 hover:text-indigo-500 px-4 py-2 w-full sm:w-auto text-center"
                  >
                    Help
                  </a>
                  <button
                    type="button"
                    onClick={handlePageOneBack}
                    className="w-full sm:w-auto flex-1 sm:flex-none rounded-md bg-gray-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                  >
                    Previous
                  </button>
                  {showFormFields && (
                    <button
                      type="submit"
                      className="w-full sm:w-auto flex-1 sm:flex-none rounded-md bg-indigo-600 px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save and Continue
                    </button>
                  )}
                </div>
              </div>
              <div className="px-4 py-4 sm:py-6 sm:p-8">

                <div className="relative mb-6 max-w-xl">
                  <div className="flex justify-between items-center mb-2">
                    <label
                      htmlFor="property-name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Business name
                    </label>
                    {!placeId && searchQuery.length >= 4 && (
                      <span className="text-sm font-medium text-indigo-600">
                        You didnt find business? Type full name.
                      </span>
                    )}
                  </div>
                  <div className="relative mt-2">
                    <textarea
                      id="property-name"
                      name="property-name"
                      rows={1}
                      autoComplete="off"
                      ref={(el) => {
                        if (el) {
                          el.style.height = 'auto';
                          el.style.height = el.scrollHeight + 'px';
                        }
                      }}
                      value={placeId || isEditing ? propertyName : searchQuery}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (placeId) {
                          resetGoogleSelection();
                          setSearchQuery(value);
                          setIsTyping(true);
                          return;
                        }
                        setIsTyping(true);
                        setSearchQuery(value);
                      }}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() =>
                        setTimeout(() => {
                          setIsFocused(false);
                          setIsTyping(false);
                          if (!placeId) setSearchQuery("");
                        }, 150)
                      }
                      placeholder="Search your business on Google"
                      className="block w-full rounded-md border border-gray-300 px-4 py-2 pr-10 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light resize-none overflow-hidden"
                    />
                    {(searchLoading || detailsLoading) && (
                      <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
                        <svg
                          className="h-5 w-5 animate-spin text-indigo-600"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                  {isFocused && !placeId && suggestions.length > 0 && (
                    <ul className="absolute z-20 mt-1 w-full bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
                      {suggestions.map((s, i) => (
                        <li
                          key={s.place_id || i}
                          onMouseDown={() => handleSelect(s)}
                          className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                        >
                          <div className="font-medium">
                            {s.structured_formatting.main_text}
                          </div>
                          <div className="text-sm text-gray-500">
                            {s.structured_formatting.secondary_text}
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                  {!placeId &&
                    searchQuery.length > 0 &&
                    searchQuery.length < 4 &&
                    !searchLoading && (
                      <p className="mt-2 text-sm text-yellow-500">
                        Type at least 4 characters to search.
                      </p>
                    )}
                  {/* {placeId && !isEditing && (
                    <p className="mt-2 text-sm text-green-600">
                      Business selected from Google. Type again to search for a
                      different business.
                    </p>
                  )} */}
                </div>

                {showFormFields && (
                  <>
                    <div className="grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 sm:gap-y-8">
                      {!logoAutoFilled && (
                        <div
                          className="col-span-full"
                          onDrop={handleDropLogoFile}
                          onDragOver={(e) => e.preventDefault()}
                        >
                          <label
                            htmlFor="logo-upload"
                            className="block text-sm font-medium mb-2 text-gray-700"
                          >
                            Business logo
                          </label>
                          <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
                            <label
                              htmlFor="logo-upload"
                              className="group relative flex h-28 w-28 cursor-pointer items-center justify-center overflow-hidden rounded-full border-2 border-dashed border-gray-400 bg-gray-50 shadow-sm transition hover:border-indigo-500 sm:h-32 sm:w-32"
                            >
                              {logoUrl ? (
                                <img
                                  src={logoUrl}
                                  alt="Property logo preview"
                                  className="h-full w-full rounded-full object-cover"
                                />
                              ) : (
                                <PhotoIcon
                                  aria-hidden="true"
                                  className="h-10 w-10 text-gray-400"
                                />
                              )}
                              <input
                                id="logo-upload"
                                name="logo-upload"
                                type="file"
                                onChange={(e) => {
                                  if (e.target.files[0]) {
                                    if (e.target.files[0].size > 10 * 1024 * 1024) {
                                      alert("Please upload a file smaller than 10MB");
                                      return;
                                    }
                                    setLogoAutoFilled(false);
                                    setLogoUrl(
                                      URL.createObjectURL(e.target.files[0]),
                                    );
                                    setLogo(e.target.files[0]);
                                    setLogoName(e.target.files[0]?.name || "");
                                  }
                                }}
                                className="sr-only"
                              />
                            </label>
                            <div>
                              <p className="text-sm text-gray-600">
                                PNG, JPG, GIF up to 10MB
                              </p>
                              {logoName && (
                                <div className="mt-2 flex items-center gap-2">
                                  <p className="text-xs leading-5 text-green-600">
                                    {logoName}
                                  </p>
                                  <button
                                    type="button"
                                    onClick={deleteLogo}
                                    className="cursor-pointer text-gray-500 hover:text-gray-700"
                                    aria-label="Remove logo image"
                                  >
                                    <TrashIcon className="h-4 w-4" />
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {!isFromGoogle("email") && (
                        <div className="sm:col-span-1">
                          <label
                            htmlFor="property-email"
                            className="block text-sm font-medium  mb-2 text-gray-700"
                          >
                            Where do you want to get the reports
                          </label>
                          <div className="mt-2">
                            <input
                              id="property-email"
                              name="property-email"
                              type="email"
                              value={propertyEmail}
                              onChange={(e) => setPropertyEmail(e.target.value)}
                              placeholder="Enter Business email"
                              className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                            />
                          </div>
                        </div>
                      )}

                      {/* Property Phone Number */}
                      {!isFromGoogle("phone") && (
                        <div className="sm:col-span-1">
                          <label
                            htmlFor="property-phone-number"
                            className="block text-sm font-medium  mb-2 text-gray-700"
                          >
                            Phone Number
                          </label>
                          <div className="flex flex-row mt-2">
                            <select
                              value={countryCode}
                              onChange={(e) => setCountryCode(e.target.value)}
                              className="rounded-l-md border-r-0 border-gray-300 py-2 pl-3 pr-8 focus:border-indigo-500 focus:ring-indigo-500 text-sm min-w-[80px] flex-shrink-0"
                            >
                              <option value="+1">+1</option>
                              <option value="+91">+91</option>
                              <option value="+44">+44</option>
                              <option value="+61">+61</option>
                              {/* Add more country codes as needed */}
                            </select>
                            <input
                              id="property-phone-number"
                              name="property-phone-number"
                              type="tel"
                              required={!isFromGoogle("phone")}
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                              placeholder="Phone number"
                              className="block flex-1 min-w-0 w-full rounded-r-md border-l-0 border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                              minLength="10"
                              maxLength="10"
                              pattern="[0-9]*"
                            />
                          </div>
                        </div>
                      )}

                      {/* Property Official Website */}
                      {!isFromGoogle("website") && (
                        <div className="sm:col-span-1">
                          <label
                            htmlFor="website"
                            className="block text-sm font-medium  mb-2 text-gray-700"
                          >
                            Business Official Website
                          </label>
                          <div className="mt-2">
                            <input
                              id="website"
                              name="website"
                              type="url"
                              value={website}
                              onChange={(e) => {
                                setWebsite(e.target.value);
                                e.target.setCustomValidity("");
                              }}
                              placeholder="Enter Business official website"
                              className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                              onInvalid={(e) => {
                                e.target.setCustomValidity(
                                  "Please enter a valid URL (example: https://example.com)",
                                );
                              }}
                            />
                          </div>
                        </div>
                      )}

                        <div className="sm:col-span-1">
                          <label
                            htmlFor="businessType"
                            className="block text-sm font-medium  mb-2 text-gray-700"
                          >
                            Business Type
                          </label>
                          <div className="mt-2">
                            <BusinessCombobox
                              options={SORTED_BUSINESS_TYPES}
                              value={businessType}
                              onChange={setBusinessType}
                              placeholder="Enter or select a business type"
                            />
                          </div>
                        </div>
                      {!isFromGoogle("reviewUrl") && (
                        <div className="sm:col-span-1">
                          <label
                            htmlFor="reviewUrl"
                            className="block text-sm font-medium  mb-2 text-gray-700"
                          >
                            Google Review URL
                          </label>
                          <div className="mt-2">
                            <input
                              id="reviewUrl"
                              name="reviewUrl"
                              type="url"
                              required={!isFromGoogle("reviewUrl")}
                              value={reviewUrl}
                              onChange={(e) => {
                                setReviewUrl(e.target.value);
                                e.target.setCustomValidity("");
                              }}
                              placeholder="Enter Google Review URL"
                              className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                              onInvalid={(e) => {
                                if (!e.target.value) {
                                  e.target.setCustomValidity(
                                    "Please enter the Google Review URL.",
                                  );
                                } else {
                                  e.target.setCustomValidity(
                                    "Please enter a valid URL",
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                      )}
                      <div className="sm:col-span-1">
                        <label
                          htmlFor="rating"
                          className="block text-sm font-medium mb-2 text-gray-700"
                        >
                          Current Google Rating
                        </label>
                        <div className="mt-2">
                          <input
                            id="rating"
                            name="rating"
                            type="number"
                            min="0"
                            max="5"
                            step="0.1"
                            value={initialRating || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setInitialRating(val);
                              e.target.setCustomValidity("");
                            }}
                            disabled={isFromGoogle("rating")}
                            placeholder="Enter Current Rating"
                            className={`block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light ${isFromGoogle("rating") ? "bg-gray-100 cursor-not-allowed" : ""}`}
                            onInvalid={(e) => {
                              if (!e.target.value) {
                                e.target.setCustomValidity("Please enter the Google Rating");
                              } else if (e.target.validity.rangeUnderflow) {
                                e.target.setCustomValidity("Rating cannot be less than 0");
                              } else if (e.target.validity.rangeOverflow) {
                                e.target.setCustomValidity("Rating cannot be greater than 5");
                              } else {
                                e.target.setCustomValidity("Please enter a valid Google rating");
                              }
                            }}
                          />
                        </div>
                      </div>

                      <div className="sm:col-span-1">
                        <div className="flex items-center mb-2">
                          <label
                            htmlFor="targetRating"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Target Rating
                          </label>
                          <div className="relative group ml-1 flex items-center">
                            <Info className="h-4 w-4 text-gray-400 cursor-help" />
                            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block w-max px-2 py-1 bg-gray-800 text-white text-xs rounded shadow-sm z-10 pointer-events-none">
                              What rating do you want to reach?
                            </div>
                          </div>
                        </div>
                        <div className="mt-2">
                          <select
                            id="targetRating"
                            name="targetRating"
                            required
                            value={targetRating}
                            onChange={(e) => {
                              setTargetRating(e.target.value);
                              e.target.setCustomValidity("");
                            }}
                            onInvalid={(e) => {
                              if (e.target.value === "") {
                                e.target.setCustomValidity("Target rating is required");
                              } else {
                                e.target.setCustomValidity("Please select a valid rating between 0 and 5");
                              }
                            }}
                            className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 text-gray-900"
                          >
                            <option value="" disabled>Select target rating</option>
                            {Array.from({ length: Math.max(0, 51 - Math.round((parseFloat(initialRating) || 0) * 10)) }).map((_, idx) => {
                              const val = ((Math.round((parseFloat(initialRating) || 0) * 10) + idx) / 10).toFixed(1);
                              return (
                                <option key={val} value={val}>
                                  {val}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      {/* About */}
                      {!isFromGoogle("about") && (
                        <div className="sm:col-span-2">
                          <label
                            htmlFor="about"
                            className="block text-sm font-medium mb-2 text-gray-700"
                          >
                            About
                          </label>
                          <div className="mt-2">
                            <textarea
                              id="about"
                              name="about"
                              rows={3}
                              value={about}
                              // required
                              onChange={(e) => setAbout(e.target.value)}
                              className="block w-full rounded-md border rows-2 border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                              placeholder="Wrtie something"
                            />
                          </div>
                        </div>
                      )}

                      {/* Country */}
                      <div className="sm:col-span-1">
                        <label
                          htmlFor="country"
                          className="block text-sm font-medium mb-2 text-gray-700"
                        >
                          Country
                        </label>
                        <div className="mt-2">
                          <select
                            id="country"
                            name="country"
                            value={country}
                            required
                            disabled={!!property?.country}
                            onChange={handleCountryChange}
                            className={`block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light ${property?.country ? 'bg-gray-100 cursor-not-allowed text-gray-500' : ''}`}
                          >
                            <option value="">Select a country</option>
                            {countries.map((countryItem) => (
                              <option key={countryItem.iso2} value={countryItem.name}>
                                {countryItem.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Zipcode */}
                      <div className="sm:col-span-1">
                        <label
                          htmlFor="zipcode"
                          className="block text-sm font-medium mb-2 text-gray-700"
                        >
                          Zipcode
                        </label>
                        <div className="mt-2">
                          <input
                            id="zipcode"
                            name="zipcode"
                            type="text"
                            value={zipcode}
                            required
                            onChange={(e) => setZipcode(e.target.value)}
                            placeholder="Enter zipcode"
                            className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                            minLength="5"
                            maxLength="6"
                          />
                        </div>
                      </div>

                      {/* State */}
                      <div className="sm:col-span-1">
                        <label
                          htmlFor="state"
                          className="block text-sm font-medium mb-2 text-gray-700"
                        >
                          State
                        </label>
                        <div className="mt-2">
                          <input
                            id="state"
                            name="state"
                            type="text"
                            value={state}
                            required
                            onChange={(e) => setState(e.target.value)}
                            placeholder="Enter state"
                            className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                          />
                        </div>
                      </div>

                      {/* City */}
                      <div className="sm:col-span-1">
                        <label
                          htmlFor="city"
                          className="block text-sm font-medium mb-2 text-gray-700"
                        >
                          City
                        </label>
                        <div className="mt-2">
                          <input
                            id="city"
                            name="city"
                            type="text"
                            value={city}
                            required
                            onChange={(e) => setCity(e.target.value)}
                            placeholder="Enter city"
                            className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                          />
                        </div>
                      </div>

                      {/* Address */}
                      <div className="sm:col-span-2">
                        <label
                          htmlFor="address"
                          className="block text-sm font-medium mb-2 text-gray-700"
                        >
                          Address
                        </label>
                        <div className="mt-2">
                          <input
                            id="address"
                            name="address"
                            type="text"
                            required
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="Enter address"
                            className="block w-full rounded-md border border-gray-300 px-4 py-2 focus:border-indigo-500 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

            </form>
          )}

          {currentStep === 2 && (
            <LinkQRStep propertyId={property?._id || propertyId} onComplete={() => setCurrentStep(3)} onShopQR={() => setCurrentStep(3)} onSuccessNavigate={() => handleFinishSetup(property?._id || propertyId)} />
          )}

          {currentStep === 3 && (
            <QRCodeKit propertyId={property?._id || propertyId} isStepContent={true} onPrevious={() => setCurrentStep(2)} onComplete={() => handleFinishSetup(property?._id || propertyId)} />
          )}
        </div>


      </div>
    </>
  );
}
